
(function () {
  /* Injection des tuiles de collection dans l'état PANIER VIDE.

     Le <template id='ntyc-empty-tpl'> du skin est cloné dans le DOM par le JS
     du skin dès que le panier devient vide. On remplit ensuite son conteneur
     .ntyc-duo, laissé vide parce que les handles 'paddle,kayak' ne résolvent
     plus rien.

     CONTRAINTES RESPECTÉES :
       · aucune expression régulière ;
       · l'observateur ne surveille QUE childList, jamais les attributs — donc
         aucun aller-retour possible avec l'observateur du skin ;
       · idempotent : marqueur data-almea-tiles sur le conteneur, et on ne
         touche jamais un .ntyc-duo qui contient déjà des tuiles (ce qui serait
         le cas si les handles étaient un jour repointés à la source) ;
       · le libellé est posé en textContent, jamais en innerHTML. */

  if (window.__almeaCartEmptyTiles) return;
  window.__almeaCartEmptyTiles = true;

  var DATA = window.ALMEA_CART_TILES || [];
  if (!DATA.length) return;

  function fillDuo() {
    var duo = document.querySelector('#mzc-drawer .ntyc-duo');
    if (!duo) return;
    if (duo.getAttribute('data-almea-tiles')) return;

    /* Des tuiles existent déjà (handles repointés à la source) : on n'y touche pas. */
    if (duo.children.length > 0) {
      duo.setAttribute('data-almea-tiles', 'native');
      return;
    }

    for (var i = 0; i < DATA.length; i++) {
      var d = DATA[i];
      if (!d || !d.url || !d.img) continue;

      var a = document.createElement('a');
      a.className = 'ntyc-tile';
      a.setAttribute('href', d.url);

      var img = document.createElement('img');
      img.setAttribute('alt', d.title || '');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.setAttribute('width', '600');
      img.src = d.img;

      var shade = document.createElement('span');
      shade.className = 'ntyc-tile-shade';

      var label = document.createElement('span');
      label.className = 'ntyc-tile-label';
      label.textContent = d.title || '';

      a.appendChild(img);
      a.appendChild(shade);
      a.appendChild(label);
      duo.appendChild(a);
    }

    duo.setAttribute('data-almea-tiles', 'injected');
  }

  fillDuo();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillDuo);
  }
  window.addEventListener('load', fillDuo);

  var delays = [200, 700, 1800];
  for (var k = 0; k < delays.length; k++) { setTimeout(fillDuo, delays[k]); }

  /* Le panier peut se vider à tout moment (suppression du dernier article) :
     l'état vide est alors cloné dans le DOM après coup. Anti-rebond simple.
     Une fois le conteneur marqué, fillDuo() ressort immédiatement : aucune
     boucle possible avec l'observateur du skin, qui se garde déjà lui-même
     par un test !body.querySelector('#ntyc-empty'). */
  try {
    var tmr = null;
    var obs = new MutationObserver(function () {
      if (tmr) clearTimeout(tmr);
      tmr = setTimeout(fillDuo, 80);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
